export var BetTypes;
(function (BetTypes) {
    BetTypes["Single"] = "Single";
    BetTypes["Combo"] = "Combo";
    BetTypes["System"] = "System";
    BetTypes["YourBet"] = "YourBet";
    BetTypes["PulseBet"] = "PulseBet";
    BetTypes["CastBet"] = "CastBet";
    BetTypes["Teaser"] = "Teaser";
})(BetTypes || (BetTypes = {}));
//# sourceMappingURL=BetTypes.js.map